<template>
	<Loading :hideInside="false" :state="true">
		<div class="auth">
			Ожидание авторизации...
		</div>
	</Loading>
</template>

<script>
	import conf from "../config";
	import store from "../store"
	import api from "../api";

	import Loading from "@/components/Loading";

	export default {
		name:    "login",
		components: {
			Loading
		},
		data() {
			return {};
		},
		async mounted() {
			try {
				await store.dispatch( "user/obtain" );

        if ( store.state.user.isLoggedIn ) {
          let url = "/";

          if ( this.$route.params.returnTo ) url = this.$route.params.returnTo;
          else if ( window.localStorage ) {
            const t = window.localStorage.getItem( "returnTo" );
            if ( t ) url = t;
          }
//          else if ( this.$route.query.returnTo ) url = this.$route.query.returnTo;

          window.localStorage.removeItem( "returnTo" );

  		  	this.$router.replace( { path: url } ).catch( err => { if ( !err.message.toLowerCase().includes( "redundant navigation" ) ) throw err; } );
	  			return;
        }
	    }
	    catch ( e ) {
				if ( e.message === "status" && e.rStatus == 403 ) return;
				console.error( e );
			}

      if ( window.localStorage ) window.localStorage.setItem( "returnTo", this.$route.params.returnTo ? this.$route.params.returnTo : "/" );
      window.location = conf.server.make( "/login" );

      //window.location = conf.server.make( "/login?returnTo=" + encodeURIComponent( this.$route.params.returnTo ) );
		},
		methods: {
		}
	};
</script>

<style scoped>
	.auth {
		text-align: center;
		color: #43525B;
		padding: 2em;
	}
</style>
